import { selectFeatureFlags } from '@ticketmaster/tm1pos-web-shared/feature-flags';
import { selectCurrentEventDetails } from '@ticketmaster/tm1pos-web-shared/store/selectors';
import { createSelector } from 'reselect';
import { selectCartId } from '../../App/selectors';
import { selectCurrentEventPaymentPermissions } from '../components/form/checkout-selectors';
import { selectFormToggles } from '../components/form/selectors';
import { selectIsEmvPayment } from '../selectors';
import type { CheckoutReduxForm } from '../types/checkout-redux-form';
import type { Identifier } from '@ticketmaster/tm1pos-web-shared/model/identifier';

export const selectLegacyCartId = createSelector(
  selectCartId,
  selectCurrentEventDetails,
  (rawCartId, currentEvent): Identifier | undefined => {
    if (rawCartId) {
      const [system, id] = rawCartId.split('-');
      if (system === 'HST') {
        return { system, id, subSystem: currentEvent?.hostName };
      }
      return { system, id };
    }
    return undefined;
  },
);

const selectIsArchticsCart = createSelector(selectLegacyCartId, (cartId) => cartId?.system === 'ARX');
const selectIsHostCart = createSelector(selectLegacyCartId, (cartId) => cartId?.system === 'HST');

export const selectIsModernCheckout = createSelector(
  selectIsArchticsCart,
  selectFeatureFlags,
  selectIsEmvPayment,
  selectFormToggles,
  (isArchtics, { modernCheckoutArchtics }, isEmvPayment, { paymentMethod }: Pick<CheckoutReduxForm, 'paymentMethod'>) =>
    isArchtics && modernCheckoutArchtics && (paymentMethod === 'Other' || isEmvPayment),
);

const selectIsPciPayment = createSelector(
  selectCurrentEventPaymentPermissions,
  selectIsEmvPayment,
  selectFormToggles,
  (paymentPermissions, isEmvPayment, { paymentMethod }: Pick<CheckoutReduxForm, 'paymentMethod'>) =>
    paymentPermissions?.mustAuthorizeCards && paymentMethod === 'Card' && !isEmvPayment,
);

export const selectIsMonitoringPurchase = createSelector(
  selectIsHostCart,
  selectFeatureFlags,
  selectIsPciPayment,
  (isHost, { monitorPurchase }, isPci) => isHost && monitorPurchase && !isPci,
);
